import React, { useEffect, useState } from 'react';
import WelcomePage from './components/WelcomePage';
import PlanLealtad from './components/PlanLealtad';
import Form from './components/Form';
import ConfirmacionFinal from './components/ConfirmacionFinal';
import NoAceptado from './components/NoAceptado';

type View = 'welcome' | 'plan' | 'form' | 'confirmacion';

const esRutaNoAceptado = window.location.pathname
  .replace(/\/+$/, '')
  .toLowerCase()
  .endsWith('/noaceptado');

function App() {
  const [view, setView] = useState<View>('welcome');
  const [nombreComercial, setNombreComercial] = useState<string>('');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [view]);

  if (esRutaNoAceptado) {
    return <NoAceptado />;
  }

  if (view === 'confirmacion') {
    return (
      <ConfirmacionFinal
        nombreComercial={nombreComercial}
        onVolver={() => {
          setNombreComercial('');
          setView('welcome');
        }}
      />
    );
  }

  if (view === 'form') {
    return (
      <Form
        onSubmit={(data) => {
          setNombreComercial(data.nombreComercial);
          setView('confirmacion');
        }}
      />
    );
  }

  if (view === 'plan') {
    return <PlanLealtad onActivate={() => setView('form')} />;
  }

  return <WelcomePage onActivate={() => setView('plan')} />;
}

export default App;
